import { render, staticRenderFns } from "./complaintTaskDetails.vue?vue&type=template&id=173b9aec&"
import script from "./complaintTaskDetails.vue?vue&type=script&lang=js&"
export * from "./complaintTaskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports